const LocationAPI = {
  getLocations () {
    // Not used anymore
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/locations.php', {
        method: 'POST'
      })
		    .then(response => response.json())
		    resolve(response)
    })
  },
  getProvinces () {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/province.php', {
        method: 'POST'
      })
		    .then(response => response.json())
		    resolve(response)
    })
  },
  getCities (province_code) {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/city.php', {
        method: 'POST',
        body: JSON.stringify({ 'province_code': province_code })
      })
		    .then(response => response.json())
		    resolve(response)
    })
  },
  getBarangay (city_code) {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/barangay.php', {
        method: 'POST',
        body: JSON.stringify({ 'city_code': city_code })
      })
		    .then(response => response.json())
		    resolve(response)
    })
  }
}
export default LocationAPI



// WEBPACK FOOTER //
// ./src/api/location.js